import PropTypes from 'prop-types';

const Step = ({ children }) => {
  return children;
};

Step.propTypes = {
  disabled: PropTypes.bool,
  prevButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
  nextButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
};

export default Step;
